export default __webpack_public_path__ + "static/media/spark_53.4a6927c1.png";